import { audio } from '../systems/audio/AudioSystem.js';

/**
 * The Tithe's collection prompt (Act III, systems/act3/LevySystem.js).
 *
 * Deliberately does NOT pause the game, unlike the level-up and Verse pickers.
 * Paying a levy is meant to cost you position and attention while the fight
 * carries on around you, and the Arrears timer underneath it is a real clock —
 * a frozen arena would remove both. So this is a small strip at the bottom of
 * the screen rather than a modal, and it stays out of the middle where the
 * bullets are.
 *
 * Pure presentation: it renders whatever tiers LevySystem says are affordable
 * and emits the choice straight back. If the player owns nothing payable the
 * system never offers, and the strip shows the refusal instead.
 */
export class LevyPrompt {
  constructor(eventBus, root) {
    this.eventBus = eventBus;
    this.root = root;
    this.el = null;

    eventBus.on('levy:offer', ({ tiers }) => this._show(tiers));
    eventBus.on('levy:paid', () => this._hide());
    eventBus.on('levy:arrears', ({ label }) => this._flash(`Taken in arrears: ${label}`));
    eventBus.on('levy:refused', () => this._flash('Nothing to give. The Tithe helps itself.'));
    eventBus.on('levy:closed', () => this._hide());
    eventBus.on('run:ended', () => this._hide());
  }

  _hide() {
    this.el?.remove();
    this.el = null;
  }

  _show(tiers) {
    this._hide();
    this.el = document.createElement('div');
    this.el.className = 'levy-prompt';

    const title = document.createElement('div');
    title.className = 'levy-prompt-title';
    title.textContent = tiers.length ? 'THE TITHE — pay to strike' : 'THE TITHE — you have nothing it wants';
    this.el.appendChild(title);

    const cards = document.createElement('div');
    cards.className = 'levy-prompt-cards';
    for (const tier of tiers) {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'levy-prompt-card';
      // Cost first, then what it buys — the whole decision is a price
      // comparison, so the price is the headline.
      card.innerHTML = `<b></b><small></small>`;
      card.querySelector('b').textContent = tier.label;
      card.querySelector('small').textContent = `opens ${tier.window}s`;
      card.addEventListener('click', () => {
        audio.playSfx('click');
        this.eventBus.emit('levy:pay', { tier: tier.id });
      });
      cards.appendChild(card);
    }
    this.el.appendChild(cards);
    this.root.appendChild(this.el);
  }

  /** A one-line notice where the prompt was, for the two paths the player didn't choose. */
  _flash(text) {
    this._hide();
    const el = document.createElement('div');
    el.className = 'levy-prompt levy-prompt-flash';
    el.textContent = text;
    this.root.appendChild(el);
    setTimeout(() => el.remove(), 2200);
  }
}
